import { Driver, Run, Task, TaskStatus } from '@bringg/types';
import { getRoot } from 'mobx-easy';

import { DetailedRun } from '../stores/routes-monitoring-store';
import RootStore from 'bringg-web/stores/root-store';
import { routesMonitoringRootStore } from '../stores/routes-monitoring-root-store';

const calculateEtaBase = (route: Run, isRealtimeEtaEnabled: boolean, driver?: Driver) => {
	if (!route.started_at || route.ended_at) {
		return undefined;
	}

	if (isRealtimeEtaEnabled && driver && driver.eta_to_home) {
		return driver.eta_to_home;
	}

	return route.scheduled_end_time;
};

export const detailedRoutesReducer = (runs: Run[], tasksByRun: Map<number, Map<number, Task>>): DetailedRun[] => {
	const {
		routeMonitoringTimelineViewStore: { isRealtimeEtaEnabled }
	} = routesMonitoringRootStore.getStore();
	const { vehiclesStore, driversStore } = getRoot<RootStore>().data;

	return runs.map(run => {
		const { fulfillment, total_cost } = [...(tasksByRun.get(run.id)?.values() || [])].reduce(
			(acc, task) => {
				if (task.status === TaskStatus.Cancelled) {
					acc.fulfillment.canceled += 1;
				}

				if (task.status === TaskStatus.Done) {
					const isRejected = task?.aggregations?.has_any_rejected_inventory;

					if (isRejected) {
						acc.fulfillment.partial_completed += 1;
					} else {
						acc.fulfillment.completed += 1;
					}
				}

				acc.total_cost += task.total_price || 0;

				return acc;
			},
			{ fulfillment: { canceled: 0, completed: 0, partial_completed: 0 }, total_cost: 0 }
		);

		return {
			...run,
			vehicle_name: vehiclesStore.get(run.vehicle_id)?.name,
			driver_name: driversStore.get(run.user_id)?.name,
			fulfillment,
			total_cost,
			task_ids: [...(tasksByRun.get(run.id)?.keys() || run.task_ids)],
			tasks_count: tasksByRun.get(run.id)?.size || 0,
			eta_to_home: calculateEtaBase(run, isRealtimeEtaEnabled, driversStore.get(run.user_id))
		};
	});
};
